"use strict";
/**
 * Shared Stripe checkout types — single source of truth for all consumers.
 *
 * WP-052: Moved from sync-server's StripeService.ts to libs/shared so that
 * downstream WPs (WP-061 Kit Marketplace Payments, WP-081 CPD Content
 * Authoring) import the same interface and prevent drift.
 */
Object.defineProperty(exports, "__esModule", { value: true });
